export const backgroundColors = ['#DFEEEA', '#D8E6F8', '#F6D9D2', '#D8DAF8', '#F5EEDF'];
export const images = [
  '/pills.png',
  '/gloves.png',
  '/heart.png',
  '/term.png',
];

export const settings = {
  dots: false,
  arrows: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4.5,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 1256,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 720,
      settings: {
        slidesToShow: 1.5,
      },
    },
  ],
};